import script from "./SeletorArquivo.vue?vue&type=script&setup=true&lang=js"
export * from "./SeletorArquivo.vue?vue&type=script&setup=true&lang=js"

import "./SeletorArquivo.vue?vue&type=style&index=0&id=5b04e438&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b04e438"]])

export default __exports__